import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=6bdbdcd5&"
var script = {}
import style0 from "./Landing.vue?vue&type=style&index=0&id=6bdbdcd5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports